module.exports = __webpack_public_path__ + "img/body-2-lg.56039796.png";